import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

// Register ag-grid modules once on first import
ModuleRegistry.registerModules([AllCommunityModule]);
